<template>
  <CRow>
    <CCol md="12">
      <HistoryTable :event="event" :items="items" :hover="true" :striped="true" :border="true" :small="true"
        :fixed="true" :dark="false" @show-detail="showDetail" @download-excel-detail="downloadExcelDetail" />
    </CCol>
    <!-- MODALES -->
    <HistoryDetailModal ref="historyDetailModal" @download-excel-detail="downloadExcelDetail"></HistoryDetailModal>
  </CRow>
</template>

<script>

// historico detalle
import HistoryTable from '@/components/events/event/detail/history/HistoryTable.vue';
import HistoryDetailModal from '@/components/events/event/detail/history/HistoryDetailModal.vue';

// Generales
import ws_history from '@/services/events_whatsapp_history';
import store from '@/store'

export default {
  name: 'HistoryModule',
  props: {
    event: { type: Object, required: true }
  },
  components: {
    HistoryTable,
    HistoryDetailModal
  },
  data() {
    return {
      items: [],
      event_id: this.$route.params.id,
    }
  },
  computed: {
  },
  mounted() {
    this.loadHistory()
  },
  methods: {
    // SERVICIOS
    async loadHistory() {
      this.loading()

      const response = await ws_history.get(this.event_id)

      if (response.type === "success") {
        this.items = response.data
      }

      this.loaded()
    },

    /* =========================
       ACCIONES
    ========================= */
    showDetail(item) {
      this.$refs.historyDetailModal.showDetail(item)
    },    
    async downloadExcelDetail(itemId) {
      this.loading()

      await ws_history.downloadExcelDetail(this.event_id, itemId)

      this.loaded()
    },

    /* =========================
       UTILS
    ========================= */
    showToast(type, message) {
      store.commit('toast', { color: type, message })
    },
    loading() { store.commit('loading') },
    loaded() { store.commit('loaded') }
  },
}
</script>
<style>

</style>